export const loading = {
  namespaced: true,
  state: {
    count: 0,
  },
  getters: {
    isActive(state) {
      return state.count > 0;
    }
  },
  mutations: {
    updateCounter(state, countModifier) {
      state.count += countModifier;
    },
  },
};
